if (!customElements.get('vb-newsletter-component')) {
  customElements.define('vb-newsletter-component', class vbNewsletterComponent extends HTMLElement {
    constructor () {
      super()
      this.elements = {
        beforeSuccessMessage: this.querySelector('[data-newsletter-el="beforeSucess"]'),
        successMessage: this.querySelector('[data-newsletter-el="successMessage"]'),
        signupForm: this.querySelector('[data-newsletter-el="signupForm"]'),
        updateForm: this.querySelector('[data-newsletter-el="updateForm"]'),
        dialog: this.querySelector('[data-newsletter-el="dialog"]'),
        closeDialog: this.querySelector('[data-newsletter-el="closeDialog"]'),
        emailInput: this.querySelector('input[name="nws-Newsletter-emailAddress"]'),
        marketInput: this.querySelector('input[name="nws-Newsletter-market"]'),
        firstNameInput: this.querySelector('input[name="nws-Newsletter-first"]'),
        lastNameInput: this.querySelector('input[name="nws-Newsletter-last"]'),
        phoneInput: this.querySelector('input[name="nws-Newsletter-phone"]'),
        dobInput: this.querySelector('input[name="nws-Newsletter-dob"]'),
        countryInput: this.querySelector('select[name="nws-Newsletter-country"]'),
      }

      this.state = {
        publicKey: 'QYzhLb',
        listID: this.dataset.listId,
        sourceName: this.dataset.sourceName,
        userProfile: {
          email: null,
          market: null,
          firstName: null,
          lastName: null,
          phone: null,
          dob: null,
          country: null,
        },
      }
    }

    connectedCallback () {
      this.elements.signupForm.addEventListener('submit', (event) => {
        event.preventDefault()
        this.state.userProfile.email = this.elements.emailInput.value
        this.state.userProfile.market = this.elements.marketInput.value

        this.subscribeUser()
      })

      this.elements.closeDialog.addEventListener('click', () => {
        this.elements.dialog.close()
      })

      this.elements.updateForm.addEventListener('submit', (event) => {
        event.preventDefault()
        this.state.userProfile.firstName = this.elements.firstNameInput.value
        this.state.userProfile.lastName = this.elements.lastNameInput.value
        this.state.userProfile.phone = this.elements.phoneInput.value
        this.state.userProfile.dob = this.elements.dobInput.value
        this.state.userProfile.country = this.elements.countryInput.value

        this.updateUser()
      })
    }

    subscribeUser () {
      const bodyData = {
        data: {
          type: 'subscription',
          attributes: {
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  subscriptions: {
                    email: {
                      marketing: {
                        consent: 'SUBSCRIBED',
                      },
                    },
                    sms: {
                      marketing: {
                        consent: 'SUBSCRIBED',
                      },
                      transactional: {
                        consent: 'SUBSCRIBED',
                      },
                    },
                    whatsapp: {
                      marketing: {
                        consent: 'SUBSCRIBED',
                      },
                      transactional: {
                        consent: 'SUBSCRIBED',
                      },
                    },
                  },
                  email: this.state.userProfile.email,
                  locale: this.state.userProfile.market,
                },
              },
            },
            custom_source: this.state.sourceName,
          },
          relationships: {
            list: {
              data: {
                type: 'list',
                id: this.state.listID,
              },
            },
          },
        },
      }

      const options = {
        method: 'POST',
        headers: {
          accept: 'application/vnd.api+json',
          revision: '2025-10-15',
          'content-type': 'application/vnd.api+json',
        },
        body: JSON.stringify(bodyData),
      }

      fetch(`https://a.klaviyo.com/client/subscriptions?company_id=${this.state.publicKey}`, options)
        .then(res => {
          if (res.status === 204 || res.status === 202) {
            this.elements.dialog.showModal()
            return
          }
          return res.text().then(text => {
            throw new Error(text)
          })
        })
        .catch(err => console.error(err))
    }

    updateUser () {
      const bodyData = {
        data: {
          type: 'profile',
          attributes: {
            location: {
              country: this.state.userProfile.country,
            },
            properties: {
              Date_Of_Birth: this.state.userProfile.dob,
            },
            email: this.state.userProfile.email,
            first_name: this.state.userProfile.firstName,
            last_name: this.state.userProfile.lastName,
            phone_number: this.state.userProfile.phone,
          },
        },
      }

      const options = {
        method: 'POST',
        headers: {
          accept: 'application/vnd.api+json',
          revision: '2025-10-15',
          'content-type': 'application/vnd.api+json',
        },
        body: JSON.stringify(bodyData),
      }

      fetch(`https://a.klaviyo.com/client/profiles?company_id=${this.state.publicKey}`, options)
        .then(res => {
          if (res.status === 204 || res.status === 202) {
            this.updateSuccess()
            return
          }
          return res.text().then(text => {
            throw new Error(text)
          })
        })
        .catch(err => console.error(err))
    }

    updateSuccess () {
      this.elements.dialog.close()
      this.elements.beforeSuccessMessage.style.display = 'none'
      this.elements.successMessage.style.display = 'block'
      this.elements.signupForm.style.display = 'none'
    }
  })
}
